import Vue from 'vue';
import {
  phoneFormatter, moneyFormatter, dateFormatter, datetimeFormatter, numbersFormatter
} from '@/utils/formatters';
import { state } from '@/store';

Vue.filter('date', dateFormatter);

Vue.filter('datetime', (val, hour12 = false) => datetimeFormatter(`${val}+00:00`, state.country.timeZone, hour12));

Vue.filter('money', (amount) => moneyFormatter(amount, state.country.money));

Vue.filter('phone', phoneFormatter);

Vue.filter('numbers', numbersFormatter);

